// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingEpostValidationErrorsReportModalRow-moduleDocFlowSendingEpostValidationErrorsReportModalRow__YdY0d TableComponent-modulerow__xPAo4";
var _2 = "DocFlowSendingEpostValidationErrorsReportModalRow-modulerecipientCell__fxdKX TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "DocFlowSendingEpostValidationErrorsReportModalRow", _2 as "recipientCell" }
